var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99994 0.902344C3.62254 0.902344 0.875 3.64982 0.875 7.02717C0.875 10.4047 3.62253 13.1523 6.99994 13.1523C10.3773 13.1523 13.1248 10.4047 13.1248 7.02717C13.1248 3.64982 10.3773 0.902344 6.99994 0.902344ZM6.99994 12.0423C4.23487 12.0423 1.98509 9.79237 1.98509 7.02717C1.98509 4.26215 4.23486 2.01244 6.99994 2.01244C9.76497 2.01244 12.0147 4.26215 12.0147 7.02717C12.0147 9.79238 9.76496 12.0423 6.99994 12.0423ZM10.0851 6.80176H7.39046V3.84465C7.39046 3.53813 7.14201 3.2896 6.83541 3.2896C6.52887 3.2896 6.28036 3.53811 6.28036 3.84465V7.35681C6.28036 7.66334 6.52887 7.91185 6.83541 7.91185H10.0851C10.3917 7.91185 10.6401 7.66333 10.6401 7.35681C10.6401 7.05027 10.3916 6.80176 10.0851 6.80176Z",
    fill: "#7F56DA",
    stroke: "#7F56DA",
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.08d7adbed82280f01ba4f29ad8670802.svg";
export { ForwardRef as ReactComponent };